/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {RedirectionService} from "../../services/redirection.service";

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html'
})
export class HelpComponent implements OnInit {

  constructor(private route: ActivatedRoute, private redirectionService: RedirectionService) {
  }

  private sessionId: any

  ngOnInit(): void {
    const that = this;
    this.sessionId = this.route.snapshot.params['sessionId'];
  }

  back() {
    this.redirectionService.session(this.route, this.sessionId);
  };

}
